import { render, staticRenderFns } from "./mAnnouncement.vue?vue&type=template&id=6a806f08&scoped=true"
import script from "./mAnnouncement.vue?vue&type=script&lang=js"
export * from "./mAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./mAnnouncement.vue?vue&type=style&index=0&id=6a806f08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a806f08",
  null
  
)

export default component.exports